import { Injectable } from '@angular/core';
import { RequestOptions } from '@angular/http';

import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import { AppSettings } from './../app.settings';

export type PortalFeature = 'LBAdmin' | 'A3IAdmin' | 'LBEAdmin' | 'HPMSAdmin' | 'NinjaAdmin';
export type FeatureToggle = {
	[key in PortalFeature]?: {
		status: 'on' | 'off'
	}
};

@Injectable()
export class FeatureToggleService {

	// The Final FeatureToggle comes from two places: 1. Database 2. Config file
	// IMPORTANT!!!: For 1.database, default status is 'off' 1. For config file, default status is 'on'
	 // This value will be set in resolver
	public featureToggle: FeatureToggle = {};
	// Complete list of features // Should include EVERY feature in LBPortal
	public readonly featureList: PortalFeature[] = ['LBAdmin', 'LBEAdmin', 'HPMSAdmin', 'A3IAdmin', 'NinjaAdmin'];
	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	public checkAvailable(feat: PortalFeature): boolean {
		if (this.featureToggle[feat]) {
			return this.featureToggle[feat].status === 'on';
		}
		return false;
	}

	async updateFeatureToggle() {
		const featureToggleDB = await this.getFeatureToggleDB();
		const featureToggleConfig: FeatureToggle = AppSettings.featureToggleConfig;
		const ft: FeatureToggle = {};
		// Update ft with list features
		this.featureList.forEach((feat) => {
			ft[feat] = {
				status: null
			};
			// Check if featureToggleDB has it, if not the feature is off
			if (featureToggleDB.hasOwnProperty(feat)) {
				// For config-file-defined feature, default is on
				if (!featureToggleConfig.hasOwnProperty(feat)) {
					featureToggleConfig[feat] = {
						status: 'on'
					};
				}
				if (featureToggleDB[feat].status === 'off' || featureToggleConfig[feat].status === 'off') {
					ft[feat].status = 'off';
				} else {
					ft[feat].status = 'on';
				}
			} else {
				ft[feat].status = 'off';
			}
		});
		// Update featureToggle value
		this.featureToggle = ft;
		return ft;
	}
	// Feature toggles passed from database (vs feature toggles in config file)
	getFeatureToggleDB() {
		return new Promise<FeatureToggle>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/featureToggle';
			const options = new RequestOptions({
				params: {
					userSubscriptionId: this.userService.getUserInfo().userSubId,
					application: 'PORTAL'
				}
			});
			this.requestService.requestGet(url, options, rsp => {
				const featureToggleDB: FeatureToggle = {};
				if (rsp.data) {
					const mapping = {
						'LB CONSOLE': 'LBAdmin',
						'HPMS Admin': 'HPMSAdmin',
						'LBE Admin': 'LBEAdmin',
						'A3I Admin': 'A3IAdmin',
						'Event Ninja Admin': 'NinjaAdmin'
					};
					rsp.data.forEach((d) => {
						const feat = mapping[d.lbt_name];
						featureToggleDB[feat] = {
							status: 'on'
						};
					});
				}
				// Compare with featureList.
				// If a feature in featureList doesn't have toggle in featureToggleDB, its status is off
				this.featureList.forEach((feat) => {
					featureToggleDB[feat] = featureToggleDB[feat] || {
						status: 'off'
					};
				});
				resolve(featureToggleDB);
			}, err => reject(err));
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/feature-toggle.service.ts